/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useEffect } from "react";

const ZoomController = () => {
  useEffect(() => {
    const setZoom = () => {
      const html = document.documentElement;
      if (!html) return;

      const ww = window.innerWidth;
      let scale = 1;
      
      if (ww >= 1200) {
        scale = ww / 1440;
      } else {
        scale = 1;
      }

      // if (ww >= 1200 && ww <= 1440) {
      //   scale = ww / 1440;
      // } else {
      //   scale = 1;
      // }

      html.style.setProperty("--zoom-scale", scale.toString());
    };

    setZoom();
    window.addEventListener("resize", setZoom);

    return () => {
      window.removeEventListener("resize", setZoom);
    };
  }, []);

  return null;
};

export default ZoomController;